import React, { Component } from "react";

import { Col } from "react-flexbox-grid";
import Paper from "material-ui/Paper";
import Subheader from "material-ui/Subheader";
import Divider from "material-ui/Divider";
import { Tabs, Tab } from "material-ui/Tabs";
import Typography from "material-ui-next/Typography";

import {
  IconButton,
  Errorable,
  Loadable,
  Page,
  StyledButton
} from "components/support";

import GeneralInfo from "./general-info";
import GeographicInfo from "./geographic-info";
import Integrations from "./integrations";
import ConfigApp from "./config-app";
/*import Plan from './plan';*/

import { colors } from "assets";

import "./company-form.css";

class CompanyForm extends Component {
  constructor(props) {
    super(props);
    this.presenter = props.presenter;
  }

  tabs = [
    { label: "Geral", component: GeneralInfo },
    { label: "Endereço", component: GeographicInfo },
    { label: "Integrações", component: Integrations },
    { label: "Configurações do Aplicativo", component: ConfigApp }
    // { label: "Plano", component: Plan },
  ];

  tabsItem = tab => {
    const { presenter, viewModel } = this.props;
    const { company, formErrors, creating } = viewModel;
    if (company) {
      return (
        <Tab label={tab.label} key={tab.label} className="tab-content">
          <tab.component
            company={company}
            errors={formErrors}
            creating={creating}
            updateVmMyFinanceIntegration={params =>
              presenter.updateVmMyFinanceIntegration(params)
            }
          />
        </Tab>
      );
    }
  };

  render() {
    const { title, error, loading } = this.props.viewModel;

    return (
      <Page>
        <Col xs={12}>
          <Typography type="display1" className="pb-sm">
            <IconButton
              icon="arrow_back"
              onClick={() => this.presenter.onGoBack()}
            />
            {title}
          </Typography>
          <Errorable error={!!error} errorMessage={error}>
            <Loadable loading={loading}>
              <Paper>
                <Subheader>
                  Os campos marcados com * são obrigatórios para emissão de Nota
                  Fiscal.
                </Subheader>

                <Tabs
                  inkBarStyle={{ backgroundColor: colors.accent.normal }}
                  tabItemContainerStyle={{
                    backgroundColor: colors.primary.dark
                  }}
                  className="company-form-tabs"
                >
                  {this.tabs.map(this.tabsItem)}
                </Tabs>

                <Divider className="mt-sm" />

                <div className="text-right p-sm">
                  <StyledButton
                    label="Cancelar"
                    onClick={() => this.presenter.onGoBack()}
                    flat
                  />

                  <StyledButton
                    primary
                    label="Salvar Empresa"
                    className="company__submit"
                    onTouchTap={() => this.presenter.onSendForm()}
                  >
                    Salvar Empresa
                  </StyledButton>
                </div>
              </Paper>
            </Loadable>
          </Errorable>
        </Col>
      </Page>
    );
  }
}

export default CompanyForm;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/company-form.view.jsx